import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import LabelText from '../../pages/components/text/LabelText';
import { BlockHead, BlockTitle } from '../Component';
import moment from 'moment';

const ViewHistoryDetailsModal = ({ isOpen, closeModal, data, title }) => {

 const [page_data, setPageData] = useState(data);
 const [open, setOpen] = useState(isOpen);

 useEffect(() => {
  setPageData(data);
  setOpen(isOpen);
 }, [data, isOpen]);

 return (
  <>
   <Modal isOpen={open} toggle={closeModal} className="modal-dialog-centered" size={"lg"}>
    <ModalHeader toggle={closeModal}>{title}</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      <LabelText
       label="Message"
       text={
        <>
         {page_data?.message || "--"}
         {page_data?.link && page_data?.view_link && (
          <>
           {" "}
           <a
            href={page_data.view_link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary text-decoration-underline ms-2"
           >
            {page_data.link_label || "View"}
           </a>
          </>
         )}
        </>
       }
      />

      <LabelText text={page_data?.timestamp ? moment(page_data?.timestamp).format("YYYY-MM-DD HH:mm:ss") : "--"} label="Timestamp" />
      {
       page_data?.name && (
        <>
         <div className="mt-4 ">
          <BlockHead>
           <BlockTitle tag="h6">Actor Details</BlockTitle>
          </BlockHead>
         </div>
         <LabelText text={page_data?.name || "--"} label="Name" />
         <LabelText text={page_data?.mobile_number || "--"} label="Mobile Number" />
         <LabelText text={page_data?.email_address || "--"} label="Email Address" />
        </>
       )
      }
     </Row>
    </ModalBody>
   </Modal>
  </>
 );
};

export default ViewHistoryDetailsModal;